export default __webpack_public_path__ + "static/media/resume.3a2412ac.pdf";